import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPdf = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_9340_24218)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M14 3V7C14 7.26522 14.1054 7.51957 14.2929 7.70711C14.4804 7.89464 14.7348 8 15 8H19",
				stroke: "currentColor",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5 12V5C5 4.46957 5.21071 3.96086 5.58579 3.58579C5.96086 3.21071 6.46957 3 7 3H14L19 8V12",
				stroke: "currentColor",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.48369 15.392C7.31035 15.392 7.94502 15.5387 8.38769 15.832C8.83035 16.12 9.05169 16.5947 9.05169 17.256C9.05169 17.9227 8.82769 18.4053 8.37969 18.704C7.93169 18.9973 7.29169 19.144 6.45969 19.144H6.06769V21H4.81969V15.536C5.09169 15.4827 5.37969 15.4453 5.68369 15.424C5.98769 15.4027 6.25435 15.392 6.48369 15.392ZM6.56369 16.456C6.47302 16.456 6.38235 16.4587 6.29169 16.464C6.20635 16.4693 6.13169 16.4747 6.06769 16.48V18.08H6.45969C6.89169 18.08 7.21702 18.0213 7.43569 17.904C7.65435 17.7867 7.76369 17.568 7.76369 17.248C7.76369 17.0933 7.73435 16.9653 7.67569 16.864C7.62235 16.7627 7.54235 16.6827 7.43569 16.624C7.33435 16.56 7.20902 16.5173 7.05969 16.496C6.91035 16.4693 6.74502 16.456 6.56369 16.456ZM11.2161 19.984C11.2748 19.9893 11.3415 19.9947 11.4161 20C11.4961 20 11.5895 20 11.6961 20C12.3201 20 12.7815 19.8427 13.0801 19.528C13.3841 19.2133 13.5361 18.7787 13.5361 18.224C13.5361 17.6427 13.3921 17.2027 13.1041 16.904C12.8161 16.6053 12.3601 16.456 11.7361 16.456C11.6508 16.456 11.5628 16.4587 11.4721 16.464C11.3815 16.464 11.2961 16.4693 11.2161 16.48V19.984ZM14.8241 18.224C14.8241 18.704 14.7495 19.1227 14.6001 19.48C14.4508 19.8373 14.2375 20.1333 13.9601 20.368C13.6881 20.6027 13.3548 20.7787 12.9601 20.896C12.5655 21.0133 12.1228 21.072 11.6321 21.072C11.4081 21.072 11.1468 21.0613 10.8481 21.04C10.5495 21.024 10.2561 20.9867 9.96813 20.928V15.528C10.2561 15.4747 10.5548 15.44 10.8641 15.424C11.1788 15.4027 11.4481 15.392 11.6721 15.392C12.1468 15.392 12.5761 15.4453 12.9601 15.552C13.3495 15.6587 13.6828 15.8267 13.9601 16.056C14.2375 16.2853 14.4508 16.5787 14.6001 16.936C14.7495 17.2933 14.8241 17.7227 14.8241 18.224ZM15.8666 21V15.456H19.5786V16.504H17.1146V17.664H19.3066V18.712H17.1146V21H15.8666Z",
				fill: "currentColor"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_9340_24218",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgPdf;
